import { combineEpics } from "redux-observable";
import { w as workspaceServicePrincipalsGetEpicReducer, a as workspaceSecurityGroupsPutEpicReducer, b as workspaceSecurityGroupsGetEpicReducer, c as workspaceServicePrincipalsPutEpicReducer, d as workspaceSecurityGroupsDeleteEpicReducer, e as workspaceMetaDataLoadEpicReducer, f as workspaceProxyStatusGetEpicReducer, h as workspaceProxyStatusUpdateEpicReducer, i as workspaceServicePrincipalsDeleteEpicReducer, u as uaaAccessGetEpicReducer } from "../../../../workspaceSettingsReducer-0ce19298.js";
const rootEpic = combineEpics(
  workspaceServicePrincipalsGetEpicReducer.epic,
  workspaceSecurityGroupsPutEpicReducer.epic,
  workspaceSecurityGroupsGetEpicReducer.epic,
  workspaceServicePrincipalsPutEpicReducer.epic,
  workspaceSecurityGroupsDeleteEpicReducer.epic,
  workspaceMetaDataLoadEpicReducer.epic,
  workspaceProxyStatusGetEpicReducer.epic,
  workspaceProxyStatusUpdateEpicReducer.epic,
  workspaceServicePrincipalsDeleteEpicReducer.epic,
  uaaAccessGetEpicReducer.epic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
